import { useEffect, useState } from 'react';

/**
 * Get Proforma Invoice from LocalStorage
 */
const getInvoiceFromLocalStorage = () => {
  let invoice = { items: [] };
  if (typeof localStorage !== 'undefined') {
    const storedInvoice = JSON.parse(localStorage.getItem('proformaInvoice'));
    if (storedInvoice && Array.isArray(storedInvoice.items)) {
      invoice = storedInvoice;
    } else {
      localStorage.setItem('proformaInvoice', JSON.stringify({ items: [] }));
    }
  }

  return invoice;
};

/**
 * Add to Proforma Invoice in LocalStorage
 */
const addToInvoiceInLocalStorage = (product) => {
  if (typeof localStorage !== 'undefined') {
    const existingInvoice = getInvoiceFromLocalStorage();

    const existingInvoiceItem = existingInvoice.items.find(
      (item) => item.priceId === product.priceId
    );

    if (existingInvoiceItem) {
      existingInvoiceItem.quantity += product.quantity;
    } else {
      existingInvoice.items.push({ ...product });
    }

    localStorage.setItem('proformaInvoice', JSON.stringify(existingInvoice));
    window.dispatchEvent(new Event('storageChange'));
  }
};
const setProductToInvoiceInLocalSotrage = (product) => {
  if (typeof localStorage !== 'undefined') {
    const existingInvoice = getInvoiceFromLocalStorage();

    const existingInvoiceItem = existingInvoice.items.find(
      (item) => item.priceId === product.priceId
    );

    if (existingInvoiceItem) {
      existingInvoiceItem.quantity = product.quantity;
    } else {
      existingInvoice.items.push({ ...product });
    }

    localStorage.setItem('proformaInvoice', JSON.stringify(existingInvoice));
    window.dispatchEvent(new Event('storageChange'));
  }
};
/**
 * ------------------------------------------------------------------------------------------------
 * Remove from Proforma Invoice in LocalStorage
 * ------------------------------------------------------------------------------------------------
 */
const removeFromInvoiceInLocalStorage = (priceId, quantity = 1) => {
  if (typeof localStorage !== 'undefined') {
    const existingInvoice = getInvoiceFromLocalStorage();

    const existingInvoiceItem = existingInvoice.items.find(
      (item) => item.priceId === priceId
    );

    if (existingInvoiceItem) {
      if (
        existingInvoiceItem.quantity === quantity ||
        existingInvoiceItem.quantity === 1
      ) {
        existingInvoice.items = existingInvoice.items.filter(
          (item) => item.priceId !== priceId
        );
      } else {
        existingInvoiceItem.quantity -= quantity;
      }

      localStorage.setItem('proformaInvoice', JSON.stringify(existingInvoice));
      window.dispatchEvent(new Event('storageChange'));
    }
  }
};

/**
 * ------------------------------------------------------------------------------------------------
 * Reset Proforma Invoice in LocalStorage
 * ------------------------------------------------------------------------------------------------
 */
const removeAllFromInvoiceInLocalStorage = () => {
  localStorage.setItem('proformaInvoice', JSON.stringify({ items: [] }));
  window.dispatchEvent(new Event('storageChange'));
};

/**
 * Custom Hook for Proforma Invoice
 */
const useProformaInvoice = () => {
  const [invoice, setInvoice] = useState(getInvoiceFromLocalStorage());

  useEffect(() => {
    const updateInvoice = () => {
      setInvoice(getInvoiceFromLocalStorage());
    };

    // Listen for storage changes
    window.addEventListener('storageChange', updateInvoice);
    return () => {
      window.removeEventListener('storageChange', updateInvoice);
    };
  }, []);

  const addProduct = (product) => {
    addToInvoiceInLocalStorage(product);
    // Update local state immediately
    const existingInvoice = getInvoiceFromLocalStorage();
    setInvoice(existingInvoice);
  };

  const removeProduct = (priceId, quantity) => {
    removeFromInvoiceInLocalStorage(priceId, quantity);
    setInvoice(getInvoiceFromLocalStorage());
  };

  const resetInvoice = () => {
    removeAllFromInvoiceInLocalStorage();
    setInvoice({ items: [] });
  };
  const setProduct = (product) => {
    setProductToInvoiceInLocalSotrage(product);
    setInvoice(getInvoiceFromLocalStorage());
  };

  return { invoice, addProduct, removeProduct, resetInvoice, setProduct };
};

export default useProformaInvoice;
